export default __webpack_public_path__ + "static/media/arrow-left.467dd09a.svg";